import cn from 'classnames';
import React, { FC } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useLocalizer } from '../../../hooks';

type GoBackProps = {
  text?: string;
  showAlways?: boolean;
  to?: string;
};

export const GoBack: FC<GoBackProps> = (props) => {
  const navigate = useNavigate();
  const { l } = useLocalizer('Global');

  const clicked = (event: React.MouseEvent<HTMLAnchorElement>) => {
    if (props.to === undefined) {
      event.preventDefault();
      navigate(-1);

      return;
    }
  };

  return (
    <div className={cn(['max-sm:flex -ml-[3px] text-in-hyperlink-blue', { flex: props.showAlways }])}>
      <Link to={props.to ?? '#'} onClick={clicked}>
        <i className="border-solid border-black border-r-2 border-b-2 border-t-0 border-l-0 inline-block p-[3px] mb-[2px] rotate-[135deg]" />
        {props.text ?? l('goBackLabel')}
      </Link>
    </div>
  );
};
